
import styled from 'styled-components';
import { SectionWithIconCardProps } from './query';
import Button_v2 from '@/components/molecules/Button/index';
import IconCard from '@/components/molecules/IconCard';
import Text from '@/components/molecules/Text';
import Title_v2 from '@/components/molecules/Title/index';
import devices from '@/utilities/devices';
import { renderUnderline } from '@/utilities/functions';

// #region STYLE
const CardsContainer = styled.section`
	display: flex;
	justify-content: center;
	width: 100%;
	> div {
		margin: 2rem 0rem 3rem;
	}
	@media screen and (${devices.mobile}) {
		flex-direction: column;
		align-items: center;
		> div {
			margin: 1rem 0rem;
		}
	}
	@media screen and (${devices.minTablet}) and (${devices.maxTablet}) {
		flex-direction: column;
		align-items: center;
		> div {
			margin: 1rem 0rem;
		}
	}
`;
// #endregion

const SectionWithIconCard = ({ sectionWithIconCardData }: { sectionWithIconCardData: SectionWithIconCardProps }) => {
	return (
		<>
			<Title_v2
				align={sectionWithIconCardData.title.alignedAt}
				underlineColor={sectionWithIconCardData.title.underlineColor}
			>
				{renderUnderline(sectionWithIconCardData.title.titlePieces)}
			</Title_v2>
			{sectionWithIconCardData.description && (
				<Text textAlign='center'>
					{sectionWithIconCardData.description}
				</Text>
			)}
			<CardsContainer>
				{sectionWithIconCardData.cards.map(
					(card, index) => (
						<IconCard
							card={card}
							key={index}
							sectionColor={sectionWithIconCardData.backgroundColor.color}
						/>
					),
				)}
			</CardsContainer>
			{
				(sectionWithIconCardData.buttons && sectionWithIconCardData.buttons.length > 0) && (
					sectionWithIconCardData.buttons.map(
						(button, index) => (
							<Button_v2
								gtm_id={button.trackerId}
								href={button.url}
								key={index}
								openOnNewTab={button.newTab}
								text={button.text}
								version={button.variant}
							/>
						),
					)
				)
			}
		</>
	);
};

export default SectionWithIconCard;
